import {ProductPriceMapping} from "../../common/models/StoreProductPrice";
import {TfStoreProduct} from "./TfStoreProduct";

export const ProductPrices: ProductPriceMapping<TfStoreProduct> = {
    TRADEFLOOR_PRO: 49.95
};
export const ProductBillingPrices = {
    TRADEFLOOR_PRO: {
        MONTH: 49.95,
        YEAR: 499
    }
};
